import { FormControl, FormControlLabel, FormHelperText, FormLabel, RadioGroup } from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import { default as React } from 'react';
import styles from './RadioGroupControl.module.css';
import classNames from 'classnames';
export function RadioGroupControl(props) {
    var _a, _b;
    var labelClasses = classNames(styles.controlLabel, (_a = {}, _a[styles.lastControlLabel] = props.removeLastControlMargin, _a));
    var radioClasses = { root: classNames(styles.controlRoot, (_b = {}, _b[styles.error] = !!props.errorText, _b)) };
    return (React.createElement(FormControl, { component: 'fieldset' },
        React.createElement(FormLabel, { component: 'legend', className: props.readOnly ? styles.readOnlyLabel : styles.label },
            props.label,
            props.required && !props.readOnly && React.createElement("span", { className: styles.labelRequired }, " *")),
        React.createElement(RadioGroup, { row: true, name: props.label, value: props.value, onChange: function (event, value) {
                if (props.readOnly)
                    return;
                props.onChange(event, value);
            } }, props.options.map(function (it) { return (React.createElement(FormControlLabel, { key: it.label, value: it.value, className: labelClasses, control: React.createElement(Radio, { disabled: props.readOnly, "data-test-id": 'radio-button_' + it.value, size: 'small', classes: radioClasses }), label: it.label })); })),
        props.showErrorHelperText && (React.createElement(FormHelperText, { classes: { root: styles.errorText } }, props.errorText ? props.errorText : ' '))));
}
